module.exports = __webpack_public_path__ + "static/media/ic_nav_search.e9209ce8.svg";